module.exports = __webpack_public_path__ + "img/10_MOBILE_TRAINING.3668b3db.png";